import { render } from "./Task.vue?vue&type=template&id=de0d1c2e&scoped=true"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"

import "./Task.vue?vue&type=style&index=0&id=de0d1c2e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-de0d1c2e"

export default script